import React from 'react';
import BookStore from './BookStore';

const BookStorePages = () => {
    return (
        <div className='container-fluid p-5' style={{ marginTop: '80px' }}>
            <BookStore />
        </div>
    );
};

export default BookStorePages;